module.exports = __webpack_public_path__ + "img/company_1.da8f282c.png";